import React, {FC, KeyboardEvent, useCallback, useEffect, useState} from 'react'
import {useLoadedData} from '../../../hooks/useGetLoadedData'
import {
  AppResponse,
  LandingPageChart,
  ShortLinkFilterParam,
} from '../../../../services/cellcast.v2.types'
import {
  useLandingPageReportChartQuery,
  useLazyLandingPageShortLinkReportExportQuery,
  useLazyLandingPageShortLinkReportQuery,
} from '../../../../services/cellcast.v2'
import {toast} from 'react-toastify'
import {Button, OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import NodataYet from '../../../Components/NodataYet'
import ReactApexChart from 'react-apexcharts'
import Select from 'react-select'
import { ENV } from '../../../Utils/_helpers/EnvHelper'
import { KTSVG } from '../../../../_metronic/helpers'
import { useResponsive } from '../../../hooks/useResponsive'
import { LandingPageMobileCard } from './components/LandingPageMobileCard'
import './LandingPage.scss'

type ShortLinkProps = {data: AppResponse<LandingPageChart> | undefined; isLoading: boolean}
const ShortLinkPage: FC = () => {
  return (
    <>
      <ShorlinkChart />
      <ShortLinkLandingPage />
    </>
  )
}

const ShorlinkChart = () => {
  const API_DOMAIN = ENV().REACT_APP_DOMAIN
  const {isMobile} = useResponsive()
  const [bulkId, setBulkId] = useState('')
  const {data, isFetching} = useLandingPageReportChartQuery({bulkId})

  const [getApiExport, {isLoading: isLoadingExport}] = useLazyLandingPageShortLinkReportExportQuery()

  const donwloadData = () => {
    getApiExport({bulkId: bulkId, page: 1, limit: 1})
      .unwrap()
      .then((res) => {
        window.open(`${API_DOMAIN}${res.data.downloadurl}`, '_self')
      })
  }

  return (
    <>
      <div className={`card py-5 mb-6 px-8 ${isMobile ? 'chart-header-mobile' : ''}`}>
        <div className={`d-flex justify-content-between align-items-start ${isMobile ? 'chart-header-section-mobile' : ''}`}>
          <div className='col-md-4 d-flex flex-column'>
            <div>
              <span className='fw-bolder fs-2 mb-1'>Landing Page Report</span>
              <OverlayTrigger
                placement='bottom'
                overlay={<Tooltip id="tooltip-bottom">
                  <span>Links submitted by users via the landing page form.</span>
                </Tooltip>}
              >
                <i
                  className='m-2 svg-icon-3 svg-icon-gray-500 cursor-pointer bi-info-circle'
                />
              </OverlayTrigger>
            </div>
            <span className='text-muted mt-1 fw-bold fs-7'>Links filled</span>
          </div>

          <div className={`col-md-4 d-flex align-items-end gap-4 ${isMobile ? 'chart-controls-mobile' : ''}`}>
            <div>
              <button type='button' onClick={donwloadData} className='btn btn-light-primary'>
                {isLoadingExport ? (
                  <Spinner size='sm' />
                ) : (
                  <>
                    <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                    Export
                  </>
                )}
              </button>
            </div>
            <div>
              <span className='card-label fw-bolder fs-2 mb-2'>Landing Page Report Filter</span>
              <Select
                onChange={(e: any) => setBulkId(e?.value)}
                options={data?.data.bulkIds}
                placeholder={data?.data?.bulkIds?.at(0)?.label}
              />
            </div>
          </div>
        </div>
      </div>

      <div className='row'>
        <ShorLinkLandingBar data={data} isLoading={isFetching} />
        <ShorLinkLandingDonut data={data} isLoading={isFetching} />
      </div>
    </>
  )
}

const ShorLinkLandingBar = ({data, isLoading}: ShortLinkProps) => {
  return (
    <div className='col-md-7'>
      <div className='card p-8 py-5 h-100'>
        <div className='card-heder border-0 p-0 align-items-center'>
          <h3 className='card-title d-flex align-items-start flex-column'>
            <div>
              <span className='fw-bolder fs-2 mb-1'>Landing Page Report</span>
              <OverlayTrigger
                placement='bottom'
                overlay={<Tooltip id="tooltip-bottom">
                  <span>Total filled link forms from landing page</span>
                </Tooltip>}
              >
                <i
                  className='m-2 svg-icon-3 svg-icon-gray-500 cursor-pointer bi-info-circle'
                />
              </OverlayTrigger>
            </div>
            <span className='text-muted mt-1 fw-bold fs-7'>Links filled</span>
          </h3>
        </div>
        <div className='card-body px-0 pt-5'>
          {isLoading ? (
            <div className='row flex-center h-200'>
              <Spinner />
            </div>
          ) : data?.data?.label?.length ? (
            <ReactApexChart
              options={{
                xaxis: {
                  categories: data?.data?.label,
                },
              }}
              series={[
                {
                  // name: 'series-1',
                  data: data?.data?.series as any,
                },
              ]}
              type='bar'
              height={350}
            />
          ) : (
            <NodataYet />
          )}
        </div>
      </div>
    </div>
  )
}

const ShorLinkLandingDonut = ({data, isLoading}: ShortLinkProps) => {
  return (
    <div className='col-md-5'>
      <div className='card p-8 py-5 h-100'>
        <div className='card-header border-0 p-0 align-items-center'>
          <h3 className='card-title align-items-start  flex-column'>
            <div>
              <span className='fw-bolder fs-2 mb-1'>Landing Page Report</span>
              <OverlayTrigger
                placement='bottom'
                overlay={<Tooltip id="tooltip-bottom">
                  <span>Total filled link forms from landing page</span>
                </Tooltip>}
              >
                <i
                  className='m-2 svg-icon-3 svg-icon-gray-500 cursor-pointer bi-info-circle'
                />
              </OverlayTrigger>
            </div>
            <span className='text-muted mt-1 fw-bold fs-7'>Links filled</span>
          </h3>
        </div>
        <div className='card-body px-0 pt-5'>
          {isLoading ? (
            <div className='row flex-center h-200'>
              <Spinner />
            </div>
          ) : data?.data?.label?.length ? (
            <ReactApexChart
              series={data?.data?.series}
              type='donut'
              options={{
                labels: data?.data?.label,
              }}
            />
          ) : (
            <NodataYet />
          )}
        </div>
      </div>
    </div>
  )
}

const ShortLinkLandingPage: FC = () => {
  const API_DOMAIN = ENV().REACT_APP_DOMAIN
  const {calculate, loadedData, setLoadedData} = useLoadedData()
  const {isMobile} = useResponsive()
  const [params, setParams] = useState<ShortLinkFilterParam>({
    page: 1,
    limit: 10,
  })

  const [triggerFetch, setTriggerFetch] = useState(false)

  const [getApiExport, {isLoading: isLoadingExport}] = useLazyLandingPageShortLinkReportExportQuery()

  const donwloadData = () => {
    getApiExport(params)
      .unwrap()
      .then((res) => {
        window.open(`${API_DOMAIN}${res.data.downloadurl}`, '_self')
      })
  }

  const [getApiExportSingle, {isLoading: isLoadingExportSingle}] = useLazyLandingPageShortLinkReportExportQuery()

  const donwloadDataSingle = (code?: string) => {
    getApiExportSingle({code, page: 1, limit: 1})
      .unwrap()
      .then((res) => {
        window.open(`${API_DOMAIN}${res.data.downloadurl}`, '_self')
      })
  }

  const [fetch, {isLoading, data, isFetching}] = useLazyLandingPageShortLinkReportQuery()

  useEffect(() => {
    fetch(params)
  }, [])

  useEffect(() => {
    if (triggerFetch && triggerFetch === true) {
      doFetch(params)
    }
    setTriggerFetch(false)
  }, [triggerFetch])

  useEffect(() => {
    if (data) {
      const loadedData = calculate(
        data && data.data.current ? data.data.current : 1,
        params.limit,
        data && data.data.total ? data.data.total : 0
      )
      setLoadedData(loadedData)
    }
  }, [isLoading, isFetching])

  const doFetch = useCallback(
    (params) => {
      fetch(params)
        .then((res: any) => {
          if ('data' in res) {
            toast.success(res.data?.message)
          } else if ('error' in res) {
            toast.error(res.error)
            console.error('Error Fetch Message:', res.error)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    },
    [fetch]
  )

  return (
    <div className='mt-8'>
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-10'>
          <div className='d-flex flex-column w-100'>
            <h3 className='card-title align-items-start  flex-column'>
              <div>
                <span className='fw-bolder fs-2 mb-1'>Landing Page Link</span>
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip id="tooltip-bottom">
                    <span>List of landing pages you have to share</span>
                  </Tooltip>}
                >
                  <i
                    className='m-2 svg-icon-3 svg-icon-gray-500 cursor-pointer bi-info-circle'
                  />
                </OverlayTrigger>
              </div>
              <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
            </h3>
            <div className={`d-flex justify-content-between ${isMobile ? 'filters-section-mobile' : ''}`}>
              <div className='d-flex justify-content-start'>
                <div className=''>
                  <div className='relative'>
                    <input
                      type='text'
                      value={params.code ? params.code : ''}
                      data-kt-user-table-filter='search'
                      className='form-control form-control-solid'
                      placeholder='input code and press enter'
                      onChange={(e: any) => setParams({...params, code: e.target.value, page: 1})}
                      onKeyDown={(event: KeyboardEvent<HTMLInputElement>) => {
                        if (event.key === 'Enter') {
                          event.preventDefault()
                          setTriggerFetch(true)
                        }
                      }}
                    />
                  </div>
                </div>
                <div className=''>
                  <div className='relative'>
                    <input
                      type='text'
                      value={params.click && params.click > 0 ? params.click : ''}
                      data-kt-user-table-filter='search'
                      className='form-control form-control-solid ms-5'
                      placeholder='input click and press enter'
                      onChange={(e: any) =>
                        setParams({...params, click: parseInt(e.target.value) || 0, page: 1})
                      }
                      onKeyDown={(event: KeyboardEvent<HTMLInputElement>) => {
                        if (event.key === 'Enter') {
                          event.preventDefault()
                          setTriggerFetch(true)
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='d-flex justify-content-end'>
                <div className='pl-4'>
                  <button type='button' onClick={donwloadData} className='btn btn-light-primary'>
                    {isLoadingExport ? (
                      <Spinner size='sm' />
                    ) : (
                      <>
                        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                        Export
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data.items && data.data.items.length > 0 ? (
              <div className={`card-body p-0 pt-1 ${isMobile ? 'px-4' : ''}`}>
                {isMobile ? (
                  <div className='mobile-landing-page-list'>
                    {isFetching ? (
                      <div className='text-center py-5'>
                        <Spinner />
                      </div>
                    ) : (
                      data?.data?.items?.map((item, i: number) => (
                        <LandingPageMobileCard
                          key={i}
                          item={item}
                          onExport={donwloadDataSingle}
                          isLoadingExport={isLoadingExportSingle}
                        />
                      ))
                    )}
                  </div>
                ) : (
                  /* Desktop view: Table layout */
                  <div className='table-responsive'>
                    <table className='table align-middle gs-0 gy-5 all-message-table'>
                      <thead>
                        <tr className='fw-400 text-muted'>
                          <th className='min-w-150px'>Shortlink</th>
                          <th className='min-w-140px'>Landing Page</th>
                          <th className='min-w-140px'>Number</th>
                          <th className='min-w-100px'>Bulk</th>
                          <th className='min-w-100px'>Click</th>
                          <th className='min-w-100px text-center'>ACTIONS</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isFetching ? (
                          <tr>
                            <td colSpan={5} className='text-center'>
                              <Spinner />
                            </td>
                          </tr>
                        ) : (
                          <>
                            {data?.data?.items?.map((item, i: number) => (
                              <React.Fragment key={i}>
                                <tr className='border-dashed border-2 border-bottom'>
                                  <td className='top-align'>{item.fullUrl || '--'}</td>
                                  <td className='top-align'>
                                    {item.landingPageData?.campaignName || '--'}
                                  </td>
                                  <td className='top-align'>{item.number || '--'}</td>
                                  <td className='top-align'>{item.bulkData?.name || '--'}</td>
                                  <td className='top-align'>{item.click}</td>
                                  <td className='text-center'>
                                    <OverlayTrigger
                                      placement='top'
                                      overlay={<Tooltip id="tooltip-top">
                                        <span>Export</span>
                                      </Tooltip>}
                                    >
                                      <Button variant='light' className='btn btn-icon' onClick={() => {
                                        donwloadDataSingle(item?.shortCode)
                                      }} disabled={isLoadingExportSingle}>
                                        {isLoadingExportSingle ? <Spinner /> : <i className='bi bi-download'></i>}
                                      </Button>
                                    </OverlayTrigger>
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))}
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
                <div className='abcd'>
                  <select
                    onChange={(e: any) => {
                      setParams({...params, limit: parseInt(e.target.value), page: 1})
                      setTriggerFetch(true)
                    }}
                    value={params.limit || 10}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  {isFetching
                    ? '. . . . .'
                    : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${
                        data?.data?.total ? data.data.total : 0
                      } Messages`}
                  {data?.data?.totalPages && data.data.totalPages > 0 && (
                    <ReactPaginate
                      previousLabel='<'
                      nextLabel='>'
                      pageCount={data.data.totalPages || 1}
                      forcePage={(params.page || 1) - 1}
                      onPageChange={(e: any) => {
                        setParams({...params, page: e.selected + 1})
                        setTriggerFetch(true)
                      }}
                      containerClassName={'pagination'}
                      previousLinkClassName={'pagination__link'}
                      nextLinkClassName={'pagination__link'}
                      disabledClassName={'pagination__link--disabled'}
                      activeClassName={'pagination__link--active'}
                    />
                  )}
                </div>
              </div>
            ) : (
              <NodataYet message='No Short Url (yet!)' />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default ShortLinkPage
